export var MULTI_STEP_DESIGN_GROUPS;
(function (MULTI_STEP_DESIGN_GROUPS) {
    MULTI_STEP_DESIGN_GROUPS["NEXT_BUTTONS_BACKGROUND"] = "next_buttons_background";
    MULTI_STEP_DESIGN_GROUPS["NEXT_BUTTONS_BACKGROUND_HOVER"] = "next_buttons_background_hover";
    MULTI_STEP_DESIGN_GROUPS["PREVIOUS_BUTTONS_BACKGROUND"] = "previous_buttons_background";
    MULTI_STEP_DESIGN_GROUPS["PREVIOUS_BUTTONS_BACKGROUND_HOVER"] = "previous_buttons_background_hover";
    MULTI_STEP_DESIGN_GROUPS["NEXT_BUTTONS_BORDER_COLOR"] = "next_buttons_border_color";
    MULTI_STEP_DESIGN_GROUPS["NEXT_BUTTONS_BORDER_COLOR_HOVER"] = "next_buttons_border_color_hover";
    MULTI_STEP_DESIGN_GROUPS["PREVIOUS_BUTTONS_BORDER_COLOR"] = "previous_buttons_border_color_background";
    MULTI_STEP_DESIGN_GROUPS["PREVIOUS_BUTTONS_BORDER_COLOR_HOVER"] = "previous_buttons_border_color_hover";
    MULTI_STEP_DESIGN_GROUPS["NEXT_BUTTONS_BORDER_SIZE"] = "next_buttons_border_size";
    MULTI_STEP_DESIGN_GROUPS["PREVIOUS_BUTTONS_BORDER_SIZE"] = "previous_buttons_border_size";
    MULTI_STEP_DESIGN_GROUPS["NEXT_BUTTONS_CORNERS"] = "next_buttons_corners";
    MULTI_STEP_DESIGN_GROUPS["PREVIOUS_BUTTONS_CORNERS"] = "previous_buttons_corners";
    MULTI_STEP_DESIGN_GROUPS["NEXT_BUTTONS_SHADOW"] = "next_buttons_shadow";
    MULTI_STEP_DESIGN_GROUPS["PREVIOUS_BUTTONS_SHADOW"] = "previous_buttons_shadow";
    MULTI_STEP_DESIGN_GROUPS["NEXT_BUTTONS_TEXT_COLOR"] = "next_buttons_text";
    MULTI_STEP_DESIGN_GROUPS["PREVIOUS_BUTTONS_TEXT_COLOR"] = "previous_buttons_text";
    MULTI_STEP_DESIGN_GROUPS["NEXT_BUTTONS_FONT"] = "next_buttons_font";
    MULTI_STEP_DESIGN_GROUPS["PREVIOUS_BUTTONS_FONT"] = "previous_buttons_font";
    MULTI_STEP_DESIGN_GROUPS["NEXT_BUTTONS_TEXT_COLOR_HOVER"] = "next_buttons_text_hover";
    MULTI_STEP_DESIGN_GROUPS["PREVIOUS_BUTTONS_TEXT_COLOR_HOVER"] = "previous_buttons_text_hover";
})(MULTI_STEP_DESIGN_GROUPS || (MULTI_STEP_DESIGN_GROUPS = {}));
export var CONTROLS_TYPES;
(function (CONTROLS_TYPES) {
    CONTROLS_TYPES["BG_COLOR_ALPHA"] = "BG_COLOR_ALPHA";
    CONTROLS_TYPES["BORDER_COLOR_ALPHA"] = "BORDER_COLOR_ALPHA";
    CONTROLS_TYPES["BORDER_SIZES"] = "BORDER_SIZES";
    CONTROLS_TYPES["BORDER_SIZE"] = "BORDER_SIZE";
    CONTROLS_TYPES["BORDER_RADIUS"] = "BORDER_RADIUS";
    CONTROLS_TYPES["TEXT_COLOR"] = "TEXT_COLOR";
    CONTROLS_TYPES["FONT"] = "FONT";
    CONTROLS_TYPES["BOX_SHADOW"] = "BOX_SHADOW";
})(CONTROLS_TYPES || (CONTROLS_TYPES = {}));
export var CONTROLS_STATES;
(function (CONTROLS_STATES) {
    CONTROLS_STATES["REGULAR"] = "regular";
    CONTROLS_STATES["HOVER"] = "hover";
    CONTROLS_STATES["FOCUS"] = "focus";
    CONTROLS_STATES["ERROR"] = "error";
})(CONTROLS_STATES || (CONTROLS_STATES = {}));
export var SECTIONS;
(function (SECTIONS) {
    SECTIONS["LABEL"] = "label";
    SECTIONS["INPUT"] = "input";
    SECTIONS["NEXT_BUTTONS"] = "next_buttons";
    SECTIONS["PREVIOUS_BUTTONS"] = "previous_buttons";
})(SECTIONS || (SECTIONS = {}));
export var COMP_PARTS;
(function (COMP_PARTS) {
    COMP_PARTS["INPUTS"] = "inputs";
    COMP_PARTS["CONTAINER"] = "container";
    COMP_PARTS["BUTTONS"] = "buttons";
})(COMP_PARTS || (COMP_PARTS = {}));
export var BASE_DESIGN_GROUPS;
(function (BASE_DESIGN_GROUPS) {
    BASE_DESIGN_GROUPS["FORM_BACKGROUND"] = "form_background";
    BASE_DESIGN_GROUPS["FORM_BORDER_COLOR"] = "form_border_color";
    BASE_DESIGN_GROUPS["FORM_BORDER_SIZE"] = "form_border_size";
    BASE_DESIGN_GROUPS["FORM_CORNERS"] = "form_corners";
    BASE_DESIGN_GROUPS["FORM_SHADOW"] = "form_shadow";
    BASE_DESIGN_GROUPS["INPUT_BACKGROUND"] = "input_background";
    BASE_DESIGN_GROUPS["INPUT_BACKGROUND_ERROR"] = "input_background_error";
    BASE_DESIGN_GROUPS["INPUT_BACKGROUND_FOCUS"] = "input_background_focus";
    BASE_DESIGN_GROUPS["INPUT_BACKGROUND_HOVER"] = "input_background_hover";
    BASE_DESIGN_GROUPS["INPUT_BORDER_COLOR"] = "input_border_color";
    BASE_DESIGN_GROUPS["INPUT_BORDER_COLOR_ERROR"] = "input_border_color_error";
    BASE_DESIGN_GROUPS["INPUT_BORDER_COLOR_FOCUS"] = "input_border_color_focus";
    BASE_DESIGN_GROUPS["INPUT_BORDER_COLOR_HOVER"] = "input_border_color_hover";
    BASE_DESIGN_GROUPS["INPUT_BORDER_SIZES"] = "input_border_sizes";
    BASE_DESIGN_GROUPS["INPUT_BORDER_SIZES_ERROR"] = "input_border_sizes_error";
    BASE_DESIGN_GROUPS["INPUT_BORDER_SIZES_FOCUS"] = "input_border_sizes_focus";
    BASE_DESIGN_GROUPS["INPUT_BORDER_SIZES_HOVER"] = "input_border_sizes_hover";
    BASE_DESIGN_GROUPS["INPUT_CORNERS"] = "input_corners";
    BASE_DESIGN_GROUPS["LABEL_TEXT_COLOR"] = "label_text_color";
    BASE_DESIGN_GROUPS["LABEL_TEXT_FONT"] = "label_text_font";
    BASE_DESIGN_GROUPS["MAIN_TEXT_COLOR"] = "main_text_color";
    BASE_DESIGN_GROUPS["MAIN_TEXT_COLOR_ERROR"] = "main_text_color_error";
    BASE_DESIGN_GROUPS["MAIN_TEXT_FONT"] = "main_text_font";
    BASE_DESIGN_GROUPS["PLACEHOLDER_TEXT_COLOR"] = "placeholder_text_color";
    BASE_DESIGN_GROUPS["LABEL_REQUIRED_TEXT_COLOR"] = "label_required_text_color";
    BASE_DESIGN_GROUPS["INPUT_SHADOW"] = "input_shadow";
})(BASE_DESIGN_GROUPS || (BASE_DESIGN_GROUPS = {}));
//# sourceMappingURL=global-design-manifest.js.map